import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { NotLoggedRoute, PrivateRoute, LoggedUserProvider } from 'contexts/user';

import LoginPage from 'pages/login';
import LogoutPage from 'pages/logout';
import RouterPage from 'pages/router';

import * as routes from 'routes';
import * as config from 'config';

const App = () => {
  return (
    <GoogleOAuthProvider clientId={config.GOOGLE_APPS_CLIENTID}>
      <LoggedUserProvider>
        <Router>
          <>
            <Switch>
              <NotLoggedRoute
                path={routes.LOGIN_ROUTE}
                component={LoginPage}
                redirect={routes.BASE_ROUTE}
              />
              <PrivateRoute path={routes.LOGOUT_ROUTE} component={LogoutPage} />
              <PrivateRoute
                path={routes.BASE_ROUTE}
                component={RouterPage}
                redirect={routes.LOGIN_ROUTE}
              />
            </Switch>
          </>
        </Router>
      </LoggedUserProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
